module.exports = __webpack_public_path__ + "static/media/SocialMedia.8bdba59e.JPG";